"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Subject = void 0;
const ZenObservable = __importStar(require("zen-observable-ts"));
/**
 * Used to be both an observable and an observer:
 * http://reactivex.io/documentation/subject.html
 */
class Subject {
    observable$;
    observedValue;
    subscriptions;
    constructor(initialValue) {
        this.subscriptions = new Set();
        this.observedValue = initialValue;
        this.observable$ = new ZenObservable.Observable((observer) => {
            this.subscriptions.add(observer);
            // Unsubscribe function
            return () => {
                this.subscriptions.has(observer) && this.subscriptions.delete(observer);
            };
        });
    }
    get observable() {
        return this.observable$;
    }
    subscribe(observer) {
        return this.observable$.subscribe(observer);
    }
    onNext(value) {
        this.observedValue = value;
        // Send out the event to the subscribers
        this.subscriptions.forEach((subscription) => {
            subscription.next(value);
        });
    }
    onComplete() {
        // Send out the event to the subscribers
        this.subscriptions.forEach((subscription) => {
            // Make sure the subscription is not already closed (in case of error)
            // istanbul ignore else
            if (!subscription.closed) {
                subscription.complete();
            }
        });
    }
    onError(errorValue) {
        // Send out the event to the subscribers
        this.subscriptions.forEach((subscription) => {
            subscription.error(errorValue);
        });
    }
    get value() {
        return this.observedValue;
    }
}
exports.Subject = Subject;
